<div  class="flex flex-row justify-between center">
  <span>{{ truncText }}</span>
  @if (canViewMore()) {
    <div>
      <!-- < button mat-flat-button color="primary" type="button" (click)="onClick($event)" class="view-more-button">...</button> -->

      <ui-button (click)="onClick($event.event)" class="view-more-button">...</ui-button>
    </div>
  }

</div>
